import React from "react";
import Container from "../primitives/Container";

/**
 * ClosingStrip — narrow dark section with a single centered serif line.
 * Used to end the Firm and Leadership pages.
 */
export const ClosingStrip = ({ children, tone = "dark" }) => {
  const isDark = tone === "dark";
  return (
    <section
      className={`${
        isDark
          ? "bg-[var(--q-bg-dark)] text-offwhite"
          : "bg-[var(--q-bg)] text-navy"
      } py-20 md:py-28`}
    >
      <Container>
        <div className="flex flex-col items-center text-center gap-6">
          <span aria-hidden="true" className="block h-px w-10 bg-gold" />
          <p className="font-serif italic text-2xl sm:text-3xl leading-[1.35] max-w-2xl">
            {children}
          </p>
          <span aria-hidden="true" className="block h-px w-10 bg-gold" />
        </div>
      </Container>
    </section>
  );
};

export default ClosingStrip;
